import { gsap } from "@gsap";

/* Verberg de letters van het logo één voor één (links naar rechts) zodra de header krimpt. */
(function () {
	var header = document.querySelector("header.pk-header");
	var text = header && header.querySelector(".header-logo-text");
	if (!text) return;

	var TIMING = { duration: 0.1, ease: "power2.out", stagger: 0.02 };

	/* De paden staan niet op leesvolgorde in de SVG, dus sorteren op x-positie. */
	var letters = gsap.utils.toArray("path", text);

	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
	var shrunk = header.classList.contains("header-shrink");

	var tl = gsap.timeline({ paused: true }).to(letters, {
		opacity: 0,
		duration: TIMING.duration,
		ease: TIMING.ease,
		stagger: TIMING.stagger
	});

	function update() {
		var shouldShrink = header.classList.contains("header-shrink");
		if (shouldShrink === shrunk) return;
		shrunk = shouldShrink;

		if (reduceMotion.matches) {
			tl.progress(shrunk ? 1 : 0);
		} else {
			shrunk ? tl.play() : tl.reverse();
		}
	}

	if (shrunk) tl.progress(1);

	new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ["class"] });
})();
